import React from "react";
import './index.scss';
import RichTextRender from "../../utils/rich-text";

interface IProp {
  calender_heading: string
  calender_subheading: string
  calender_body: any
  image: {
    alt: string
    url: string
  }
  calender_embed: {
    url: string
  }
  calender_title: string
  className?: string
}

const Calender: React.FC<IProp> = ({ calender_heading, calender_subheading, calender_body, image, calender_embed, calender_title, className }) => {
  const show = !!calender_heading || !!calender_subheading || !!(calender_body?.text?.trim()) || !!image?.url || !!(calender_embed?.url.trim()) || !!calender_title;
  const showText = !!calender_heading || !!calender_subheading || !!(calender_body?.text?.trim())
  const showBody = !!image?.url || !!showText;

  return <>
    {show ? <section id="custom-calender-cal-style" className={className}>
      < div className="container">
        <div id="" className="">
          {showBody ? <div className="row flex justify-center">
            {showText ? <div className="col-12 col-lg-6 text-left custom-cal-text-section">
              {calender_heading ? <h2>{calender_heading}</h2> : null}
              {calender_subheading ? <h3>{calender_subheading}</h3> : null}
              {calender_body ? <div className="">
                {RichTextRender(calender_body)}
              </div> : null}
            </div> : null}
            {image?.url ? <div className="col-12 col-lg-4 text-center flex justify-center">
              <img className="custom-cal-img"
                alt={image.alt}
                src={image?.url}
              />
            </div> : null}
          </div> : null}
        </div>
        <div>
          {calender_embed?.url ? <iframe
            title={calender_title}
            style={{
              width: "100%",
              height: "719px",
            }}
            src={calender_embed?.url}
          /> : null}
        </div>
      </div >
    </section > : null}
  </>
}

export default Calender;